"use client";

import React from "react";
import { motion } from "framer-motion";

export default function NavigationDock({ activeTab, setActiveTab }: { activeTab: string, setActiveTab: (tab: string) => void }) {
    const navItems = ["Hikari", "Journal", "Collab"];

    return (
        <div className="fixed bottom-8 left-1/2 -translate-x-1/2 z-50">
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-2xl border border-white/20 rounded-full px-2 py-2 shadow-2xl">
                {navItems.map((item) => {
                    const isActive = activeTab === item;
                    return (
                        <button
                            key={item}
                            onClick={() => setActiveTab(item)}
                            className="relative px-6 py-2 rounded-full overflow-hidden group bg-transparent transition-colors duration-300"
                        >
                            <span
                                className={`relative z-10 text-xs font-bold tracking-widest uppercase transition-colors duration-300 ${isActive ? "text-neutral-900" : "text-white group-hover:text-black"
                                    }`}
                            >
                                {item}
                            </span>
                            {/* Active Background (Persistent) */}
                            {isActive && (
                                <motion.div
                                    className="absolute inset-0 bg-white"
                                    layoutId="nav-bg"
                                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                                />
                            )}

                            {/* Hover Background (Transient) */}
                            {!isActive && (
                                <motion.div
                                    className="absolute inset-0 bg-white"
                                    initial={{ opacity: 0 }}
                                    whileHover={{ opacity: 1 }}
                                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                                />
                            )}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
